(function ($, Drupal, once) {
  'use strict';
  Drupal.behaviors.weaver_tailwind_curved = {

    setRoundedColumnsBGImage: function() {
      const roundedColumns = document.querySelectorAll('.paragraph--type--ptb-2col-curved-image .ptb-bg-image');
      if (roundedColumns.length <= 0) {
        return;
      }

      roundedColumns.forEach(column => {
        column.style.backgroundImage = 'url(' + column.dataset.smImage + ')';
        if (window.screen.width >= 768) {
          column.style.backgroundImage = 'url(' + column.dataset.xlImage + ')';
        }
      });
    },

    attach: function (context, settings) {

      $(once('weaver_tailwind_curved', 'body', context)).each(function () {
        const weaver_curved = Drupal.behaviors.weaver_tailwind_curved;

        weaver_curved.setRoundedColumnsBGImage();

        window.addEventListener('resize', () => {
          weaver_curved.setRoundedColumnsBGImage();
        });
      });
    }
  };
})(jQuery, Drupal, once);